module.exports = __webpack_public_path__ + "static/media/DragonCity.4afe70ea.env";